<p-table
	[value]="liste"
	[paginator]="true"
	[alwaysShowPaginator]="true"
	[rows]="10"
	[totalRecords]="liste.length"
	currentPageReportTemplate="{{liste.length| number}} {{'common.table_total_records'|translate}}"
	paginatorDropdownAppendTo="body"
	[rowsPerPageOptions]="[10]"
	styleClass="p-datatable-sm p-datatable-gridlines table-scrollable-hover"
	[autoLayout]="true"
	responsiveLayout="scroll"
	class="h-50rem block"
>
	<!-- Header -->
	<ng-template pTemplate="header">
		<tr>
			<th class="text-center min-w-10rem nowrap">
				{{ 'textes.date_application' | translate }}
			</th>

			<th class="text-center nowrap min-w-20rem xl:min-w-50rem">
				{{ (mode == 'targeted' ? 'textes.target_texte_reference': 'textes.modifying_texte_reference') | translate }}
			</th>

			<th class="text-center min-w-15rem xl:min-w-30rem">
				{{ (mode == 'targeted' ? 'textes.target_texte_rubriques': 'textes.modifying_texte_rubriques') | translate }}
			</th>
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-info>
		<tr>
			<!-- Date d'application -->

			<td class="text-center">{{info.otm_date_application | date:'shortDate'}}</td>
			<!-- Titre du texte cible, avec lien vers le texte -->
			<td class="text-center">
				<span
					(click)="replaceModalWithTextModal(info.txt_id)"
					class="text-blue-500 underline cursor-pointer"
				>
					{{info.txt_reference}}
				</span>
			</td>

			<!-- Rubriques du texte cible -->
			<td class="text-center">
				<div class="mb-1" *ngIf="info.rubriques.length">
					{{info.rubriques[0] | nomenclature}}
				</div>

				<ng-container *ngIf="info.rubriques.length > 1">
					<p-accordion class="accordion-transparent">
						<p-accordionTab [header]="'common.and_x_more'|translate:{number: info.rubriques.length -1}">
							<ng-container *ngFor="let rub of info.rubriques; first as isFirst">
								<div class="text-sm mb-1" *ngIf="!isFirst">
									• {{rub | nomenclature}}
								</div>
							</ng-container>
						</p-accordionTab>
					</p-accordion>
				</ng-container>
			</td>
		</tr>
	</ng-template>

</p-table>